<div fxLayout="row">
  <div fxFlex="80" style="height: 50px">
    <abcSelectBox [dataSource]="getDocuments$ | async" [displayExpr]="'name'" [(value)]="selectedDocument">
    </abcSelectBox>
  </div>
</div>
